export interface Perfil {
  CODPERFIL: number;
  TITULO: string;
  DESCRICAO: string;

  // Campo de atribuição do perfil de acesso para o usuário
  ATIVO?: boolean;
}

export enum EnumPerfis {
  ADMINISTRADOR = 1,
  GESTOR = 2,
  SUPERVISOR = 3,
  GERAL = 4,
}
